import { createSelector } from '@ngrx/store';
import {
  selectDigitaixState
} from '../core.selectors';
import { isAuthEnabled } from '../config/config.selectors';
import { LIFE_CYCLE_INIT } from './life-cycle.reducer';

export const selectLifeCycleState = createSelector(
  selectDigitaixState,
  state => state ? state.lifeCycle : LIFE_CYCLE_INIT,
);

export const isAppStable = createSelector(
  selectLifeCycleState,
  state => state.stable
);

export const isAppNavigated = createSelector(
  selectLifeCycleState,
  state => state.navigated
);

export const isAppNavigating = createSelector(
  isAppNavigated,
  navigated => !navigated
);

export const isAppConfigLoaded = createSelector(
  selectLifeCycleState,
  state => state.config,
);

export const isAppAuth = createSelector(
  selectLifeCycleState,
  isAuthEnabled,
  (state, enabled) => enabled === false || state.auth !== null
);

export const isAppDocumentServiceLoaded = createSelector(
  selectLifeCycleState,
  state => state.documentService
);

export const isAppInit = createSelector(
  selectLifeCycleState,
  state => state.init
);

export const isAppReady = createSelector(
  isAppInit,
  isAppDocumentServiceLoaded,
  isAppAuth,
  isAppConfigLoaded,
  isAppStable,
  (isInit, isDocumentServiceLoaded, isAuth, isConfigLoaded, isStable) => isInit && isDocumentServiceLoaded && isAuth && isConfigLoaded && isStable,
);
